import * as T from './types'

const Headphone = (props: T.ISVGProps) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 68 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 39.5V45.1667C11.3333 48.2963 13.8703 50.8334 16.9999 50.8334C20.1295 50.8334 22.6666 48.2963 22.6666 45.1667V39.5C22.6666 36.3704 20.1295 33.8334 16.9999 33.8334C13.8703 33.8334 11.3333 36.3704 11.3333 39.5ZM11.3333 39.5V31C11.3333 24.9885 13.7213 19.2231 17.9722 14.9723C22.223 10.7215 27.9883 8.33337 33.9999 8.33337C40.0115 8.33337 45.7768 10.7215 50.0277 14.9723C54.2785 19.2231 56.6666 24.9885 56.6666 31V39.5M56.6666 39.5C56.6666 36.3704 54.1295 33.8334 50.9999 33.8334C47.8703 33.8334 45.3333 36.3704 45.3333 39.5V45.1667C45.3333 48.2963 47.8703 50.8334 50.9999 50.8334M56.6666 39.5V45.1667C56.6666 48.2963 54.1295 50.8334 50.9999 50.8334M50.9999 50.8334C50.9999 53.0877 49.2089 55.2497 46.0207 56.8438C42.8326 58.4378 38.5086 59.3334 33.9999 59.3334"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Headphone
